import { CashIcon } from './CashIcon';

/**
 * author: Austin Andrews
 * id 59956D81-BF6B-4DCA-ABAD-A890412F22F1
 * name cash
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash.svg
 * tags
 * - Currency 
 * - Banking 
 * - Shopping 
 */
export const MoneyIcon = CashIcon;
export default MoneyIcon